var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Children } from "react";
import { isTableActionItemProps } from "./TableActionItem";
import ActionMenuItem from "../menu/ActionMenuItem";
import { isTableActionHeaderProps } from "./TableActionHeader";
import { isTableActionSubMenuProps } from "./TableActionSubMenu";
import ActionMenuHeader from "../menu/ActionMenuHeader";
import ActionMenuSeparator from "../menu/ActionMenuSeparator";
import ActionSubMenu from "../menu/ActionSubMenu";
import { cellActions } from "./utils";
import KebabActionMenu from "../menu/KebabActionMenu";
export const TableKebabActionMenu = (props) => {
    const actionsAdapter = () => __awaiter(void 0, void 0, void 0, function* () {
        const tableActions = typeof props.actions === "function" ? yield props.actions(props.params) : props.actions;
        const renderActionItems = (items) => items && renderTableActionAsActionItems(items, props.params, props["data-insights"]);
        return renderActionItems(typeof props.actions === "function"
            ? cellActions(tableActions)
            : props.actions);
    });
    return (React.createElement(KebabActionMenu, { id: props.id, "aria-label": props["aria-label"], actions: actionsAdapter, "data-insights": props["data-insights"], handleQuickFind: props.handleQuickFind }));
};
export const fromActionIdToUniqueId = (id, actionId) => `${id}_action_$${actionId}`;
export const fromUniqueIdToActionId = (uniqueId) => uniqueId.slice(uniqueId.indexOf("$") + 1);
const renderTableActionAsActionItem = (props, index, params, parentInsightsAttr) => {
    if (isTableActionItemProps(props)) {
        const { id: actionId, "data-insights": actionItemInsightsAttr, label, iconName, href, to, as, onClick, disabled, } = props;
        const id = fromActionIdToUniqueId(params.id, actionId);
        const insightsAttr = actionItemInsightsAttr || parentInsightsAttr;
        const actionInsightsAttr = insightsAttr && fromActionIdToUniqueId(insightsAttr, actionId);
        return (React.createElement(ActionMenuItem, { id: id, as: as, "data-insights": actionInsightsAttr, key: id, label: label, iconName: iconName, to: href || to, onClick: () => {
                onClick === null || onClick === void 0 ? void 0 : onClick(params);
            }, disabled: disabled }));
    }
    if (isTableActionHeaderProps(props)) {
        const { title, iconName } = props;
        return React.createElement(ActionMenuHeader, { key: `header-${index}`, title: title || "", iconName: iconName });
    }
    return React.createElement(ActionMenuSeparator, { key: `separator-${index}` });
};
export const renderTableActionAsActionItems = (children, params, insightsAttr, hide) => {
    return children.map((action, index) => {
        if (isTableActionSubMenuProps(action)) {
            const { id, label, iconName, maxHeight, bare, children: submenuChildren, ["aria-label"]: ariaLabel, } = action;
            const submenuChildrenProps = renderTableActionAsActionItems(Children.map(submenuChildren, (c) => {
                if (React.isValidElement(c)) {
                    return c.props;
                }
                return null;
            }).filter(Boolean), params, insightsAttr, hide);
            return (React.createElement(ActionSubMenu, { id: id, label: label, iconName: iconName, "aria-label": ariaLabel, key: `sub-menu-${id}`, maxHeight: maxHeight, bare: bare }, submenuChildrenProps));
        }
        else {
            return renderTableActionAsActionItem(action, index, params, insightsAttr);
        }
    });
};
//# sourceMappingURL=KebabWithPortal.js.map